<template>
    <div>
        <el-dialog
            title="选择发票"
            :visible.sync="dialogVisible"
            width="800px" class="invoiceTitleDialogBox">
            <div class="invoiceTitleDialog">
                <el-button type="text" class="addInvoice" @click="toInvoiceDialog('add','')">新增发票</el-button>
                <el-tabs v-model="activeName" @tab-click="searchInfo">
                    <el-tab-pane label="电子发票" name="DZFP"></el-tab-pane>
                    <el-tab-pane label="纸质发票" name="ZZFP"></el-tab-pane>
                </el-tabs>
                <div class="electronicInvoice" v-if="activeName === 'DZFP'">
                    <h3>请选择发票</h3>
                    <div class="invoiceList">
                        <div class="invoiceItem" v-for="(item,index) in electronicInvoiceList" :key="index">
                            <el-checkbox v-model="item.checked" class="invoiceCheckBox"
                                         @change="invoiceCheckChange(item)"></el-checkbox>
                            <div>
                                <div class="type">
                                    {{item.invoiceType=='SPECIAL'?'专用发票':'普通发票'}} ({{item.billType=='ENTERPRISE'?'企业':'个人'}})
                                </div>
                                <div class="name">{{item.title}}</div>
                                <div class="num" v-if="item.code">{{item.code}}</div>
                            </div>
                            <el-button type="text" class="edit" @click="toInvoiceDialog('edit',item.uuid)">编辑</el-button>
                        </div>
                    </div>
                </div>
                <div class="electronicInvoice" v-if="activeName === 'ZZFP'">
                    <h3>请选择发票</h3>
                    <div class="invoiceList">
                        <div class="invoiceItem" v-for="(item,index) in electronicInvoiceList" :key="index">
                            <el-checkbox v-model="item.checked" class="invoiceCheckBox"
                                         @change="invoiceCheckChange(item)"></el-checkbox>
                            <div>
                                <div class="type">
                                    {{item.invoiceType=='SPECIAL'?'专用发票':'普通发票'}}
                                </div>
                                <div class="name">{{item.title}}</div>
                                <div class="num" v-if="item.code">{{item.code}}</div>
                            </div>
                            <el-button type="text" class="edit" @click="toInvoiceDialog('edit',item.uuid)">编辑</el-button>
                        </div>
                    </div>
                    <h3>请选择收票地址</h3>
                    <div class="addressList">
                        <div :class="item.checked?'active addressItem':'addressItem'" v-for="(item,index) in addressList" :key="index">
                            <el-checkbox class="checkBox" v-model="item.checked" @change="addressChecked(item)"></el-checkbox>
                            <div class="name">{{item.receiverName}} <el-button v-if="item.checked" type="text" icon="el-icon-edit" style="padding: 0;position: relative;z-index: 9;" @click="toEditAddress(item)"></el-button></div>
                            <div class="tel">{{item.mobile}}</div>
                            <div class="address">{{ item.province }}{{ item.city }}{{ item.district }}{{ item.areaInfo }}</div>
                            <img v-if="item.checked" src="@/assets/addressBorder.png" class="addressBorder">
                        </div>
                    </div>
                </div>
                <div class="buttonGroup">
                    <el-button @click="dialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="selectInvoice">选择</el-button>
                </div>
            </div>
        </el-dialog>
        <!--发票新增编辑-->
        <add-invoice-dialog ref="addInvoiceDialogRef"></add-invoice-dialog>
    </div>
</template>

<script>
    import { invoiceTitleList,getAddressList } from '../../utils/interface';
    import addInvoiceDialog from './addInvoiceDialog'
    export default {
        name: "invoiceTitleDialog",
        data() {
            return {
                dialogVisible: false,
                activeName: 'DZFP',
                emailRadio: '',
                invoiceType:"NORMAL",
                electronicInvoiceList: [],
                addressList: [],
                invoiceUuid:"",
                addressUuid:"",
            }
        },
        components: {
            addInvoiceDialog
        },
        methods: {
            invoiceTitleList(){
                this.getInvoiceList();
            },
            searchInfo(){
                if(this.activeName==="DZFP"){
                  this.invoiceType = "NORMAL";
                }else if(this.activeName==="ZZFP"){
                  this.invoiceType = "";
                }
                this.electronicInvoiceList = [];
                this.getInvoiceList();
            },
            getInvoiceList(){
                let params = {
                    invoiceType:this.invoiceType
                };
                invoiceTitleList(params).then((res)=>{
                    if(res&&res.length>0){
                        res.map(item=>{
                            if(item.uuid == this.invoiceUuid){
                                item.checked = true;
                            }else {
                                item.checked = false;
                            }
                        });
                    }
                    this.electronicInvoiceList = res;
                });
            },
            getAddressList(){
                getAddressList().then((res) => {
                    res.data.map(item => {
                        if(item.uuid == this.addressUuid){
                            item.checked = true;
                        }else {
                            item.checked = false;
                        }
                    });
                    this.addressList = res.data;
                });
            },
            init(val) {
                console.log(val);
                this.reset();
                if(JSON.stringify(val)!='{}'){
                    // 存在数据回显
                    this.activeName = val.invoiceType!=undefined?val.invoiceType:this.activeName;
                    if (this.activeName == "DZFP") {
                        this.invoiceUuid = val.invoiceUuid;
                    } else {
                        this.invoiceUuid = val.invoiceUuid;
                        this.addressUuid = val.payeeUuid;
                    }
                }
                this.getInvoiceList();
                this.getAddressList();
                this.dialogVisible = true;
            },
            // 选择电子发票复选框
            invoiceCheckChange(val) {
                this.electronicInvoiceList.map(item => {
                    if (val.uuid !== item.uuid) {
                        item.checked = false
                    } else {
                        item.checked = val.checked
                    }
                })
            },
            // 地址选中事件
            addressChecked(val) {
                this.addressList.map(item => {
                    if (item.uuid === val.uuid) {
                        item.checked = val.checked
                    } else {
                        item.checked = false
                    }
                })
            },
            // 选择发票确认
            selectInvoice() {
                if (this.activeName === 'DZFP') {
                    let electronicInvoiceSelected = this.electronicInvoiceList.filter(item => {
                        return item.checked === true
                    });
                    if (electronicInvoiceSelected.length <= 0) {
                        this.$message.warning('请选择发票!')
                    } else {
                        // 电子发票
                        // 查询企业还是个人
                        let arr = new Array;
                        arr.activeName = this.activeName;
                        arr.name = "电子普通发票";
                        arr.title = electronicInvoiceSelected[0].title;
                        arr.uuid = electronicInvoiceSelected[0].uuid;
                        arr.type = electronicInvoiceSelected[0].billType == "PERSONAL"?"个人":"企业";
                        // 发票邮箱
                        arr.email = electronicInvoiceSelected[0].payeeEmail;
                        this.$emit('selectInvoice',arr);
                        this.dialogVisible = false
                    }
                } else {
                    let paperInvoiceSelected = this.electronicInvoiceList.filter(item => {
                        return item.checked === true
                    });
                    let addressSelected = this.addressList.filter(item => {
                        return item.checked === true
                    });
                    if (paperInvoiceSelected.length <= 0) {
                        this.$message.warning('请选择发票!')
                    } else if (addressSelected.length <= 0) {
                        this.$message.warning('请选择收票地址!')
                    } else {
                        let arr = new Array;
                        arr.activeName = this.activeName;
                        arr.uuid = paperInvoiceSelected[0].uuid;
                        arr.name = paperInvoiceSelected[0].invoiceType = "NORMAL"?"纸质普通发票":"纸质专用发票";
                        arr.type = paperInvoiceSelected[0].billType == "PERSONAL"?"个人":"企业";
                        // 发票信息
                        // 电话
                        arr.payeeTel = paperInvoiceSelected[0].payeeTel;
                        // 抬头
                        arr.title = paperInvoiceSelected[0].title;
                        // 企业用户
                        // 税号
                        arr.code = paperInvoiceSelected[0].code;
                        // 开户银行
                        arr.bank = paperInvoiceSelected[0].bank;
                        // 银行账号
                        arr.bankAccount = paperInvoiceSelected[0].bankAccount;
                        // 注册地址
                        arr.address = paperInvoiceSelected[0].address;
                        // 注册电话
                        arr.mobile = paperInvoiceSelected[0].mobile;
                        arr.uuid = paperInvoiceSelected[0].uuid;
                        // 收票地址
                        arr.receiverName = addressSelected[0].receiverName;
                        arr.mobile1 = addressSelected[0].mobile;
                        arr.payeeAddress = addressSelected[0].province+addressSelected[0].city+addressSelected[0].district+addressSelected[0].areaInfo;
                        arr.payeeUuid = addressSelected[0].uuid;
                        this.$emit('selectInvoice',arr);
                        this.dialogVisible = false
                    }
                }
            },
            // 重置
            reset(){
                this.addressList.map(item => {
                    item.checked = false
                });
                this.electronicInvoiceList.map(item => {
                    item.checked = false
                });
                this.emailRadio = '';
                this.activeName = 'DZFP';
            },
            // 点击打开新增/编辑发票弹框
            toInvoiceDialog(type,uuid){
                this.$refs.addInvoiceDialogRef.init(type,uuid)
            }
        }
    }
</script>

<style scoped lang="less">
    .addInvoice {
        position: absolute;
        right: 22px;
        top: 80px;
        z-index: 999;
    }
    
    .electronicInvoice {
        h3 {
            padding-bottom: 15px;
            color: #000;
            font-size: 15px;
        }
        
        .invoiceList {
            .invoiceItem {
                border: 1px solid #ddd;
                padding: 10px 50px 10px 15px;
                border-radius: 10px;
                margin-bottom: 15px;
                display: flex;
                align-items: center;
                position: relative;
                
                .invoiceCheckBox {
                    padding-right: 15px;
                }
                
                .type {
                    font-size: 12px;
                    color: #666;
                    padding-bottom: 5px;
                }
                
                .name {
                    font-size: 15px;
                    color: #000;
                    padding-bottom: 5px;
                }
                
                .num {
                    font-size: 12px;
                    color: #333;
                }
                
                .edit {
                    position: absolute;
                    right: 15px;
                    top: 50%;
                    margin-top: -10px;
                    padding: 0;
                }
            }
        }
        
        .emailList {
            padding: 0 15px 15px;
            
            /deep/ .el-radio {
                margin-bottom: 15px;
                display: block;
                margin-right: 0;
            }
        }
    }
    
    .buttonGroup {
        width: 100%;
        text-align: right;
    }
    
    .addressList {
        padding: 24px 15px 0;
        display: flex;
        flex-wrap: wrap;
        
        .addressItem {
            padding: 14px 22px;
            margin-bottom: 24px;
            margin-right: 30px;
            position: relative;
            width: 270px;
            border-radius: 8px;
            border: 2px dashed #E3E3E3;
            font-size: 14px;
            
            .addressBorder {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
            }
            
            &.active {
                border: 2px dashed #fff;
            }
            
            &:nth-of-type(4n) {
                margin-right: 0;
            }
            
            .checkBox {
                position: absolute;
                right: 22px;
                top: 14px;
            }
            
            .name {
                color: #000;
            }
            
            .tel {
                color: rgba(51, 51, 51, 0.85);
                padding: 6px 0;
            }
            
            .address {
                color: rgba(51, 51, 51, 0.85);
                line-height: 22px;
            }
        }
        
        .addItem {
            text-align: center;
            cursor: pointer;
            color: #666;
            
            &:hover {
                border: 2px dashed #1890FF;
            }
            
            .icon {
                font-size: 30px;
            }
            
            .addName {
                font-size: 14px;
                padding-top: 5px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/print/invoiceTitleDialog.vue